export const CountryCode = {
  'AUS': 'AUS',
  'CHN': 'CHN',
  'HKG': 'HKG',
  'IND': 'IND',
  'JPN': 'JPN',
  'KOR': 'KOR',
  'NZL': 'NZL',
  'PHL': 'PHL',
  'SGP': 'SGP',
  'IDN': 'IDN',
  'THA': 'THA',
  'TWN': 'TWN',
  'VNM': 'VNM',
  'USA': 'USA',
};

export const CountryName = {
  [CountryCode.AUS]: 'Australia',
  [CountryCode.CHN]: 'China',
  [CountryCode.HKG]: 'Hong Kong',
  [CountryCode.IND]: 'India',
  [CountryCode.JPN]: 'Japan',
  [CountryCode.KOR]: 'Korea',
  [CountryCode.NZL]: 'New Zealand',
  [CountryCode.PHL]: 'Philippines',
  [CountryCode.SGP]: 'Singapore',
  [CountryCode.IDN]: 'Indonesia',
  [CountryCode.THA]: 'Thailand',
  [CountryCode.TWN]: 'Taiwan',
  [CountryCode.VNM]: 'Vietnam',
  [CountryCode.USA]: 'United States',
};